import * as Types from 'src/actions/modal/clear/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';

export interface ClearModals extends Action {
  type: Types.CLEAR_MODAL;
}

export const clearModals: ActionCreator<ClearModals> = () => {
  return (
    {
      type: Types.CLEAR_MODAL
    }
  );
};



// WEBPACK FOOTER //
// ./src/actions/modal/clear/Clear.actions.tsx